export default "__VITE_ASSET__DXjkIrPl__"